import { put, select, takeEvery, cancel } from 'redux-saga/effects';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import actions from '../actions';
import chatConsts from '../constants';
import { availableChannelsSelector } from '../selectors';

function* updateChannelInboxTaskWorker({ payload }) {
  const { kind } = { ...payload };

  if (kind !== 'message') {
    yield cancel();
  }

  const { patient } = { ...payload };
  const { id: patientId } = patient;

  const availableChannels = yield select(availableChannelsSelector);

  const availablePatientChannel = get(availableChannels, [patientId], {});

  if (!availablePatientChannel || isEmpty(availablePatientChannel)) {
    yield cancel();
  }

  yield put(actions.updateChannelInboxTaskId(payload));
}

export default function* updateChannelInboxTaskSaga() {
  yield takeEvery(
    [chatConsts.COMPLETE_INBOX_TASK],
    updateChannelInboxTaskWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/update-channel-inbox-task-id-saga.js